import React, { useEffect } from 'react'
import { flushSync } from 'react-dom'
import FormInputs from '../../../components/UI/FormInputs'
import { isSet } from '../../../utils/commonUtils'
import IncidentService from '../../../services/IncidentService';
import WithRoutify from '../../../hoc/WithRoutify';
import Buttons from '../../../components/UI/Buttons';
import EmrConfigService from '../../../services/EmrConfigService';
import EmrVisitsService from '../../../services/EmrVisitsService';
import Alert from '../../../components/UI/ConfirmBox/Alert';
import WorkRestrictionsModal from './WorkRestrictionsModal';
import PERMISSIONS from '../../../utils/AclPermissions';
import Icons from '../../../components/UI/Icons';
import AiDiagnosisService from '../../../services/AiDiagnosisService';
import { Modal } from 'react-bootstrap';

const WorkRestrictionsTab = (props) => {
      const {
            isChartingSectionDirty,
            setIsChartingSectionDirty,
            showUnsavedAlert,
            setShowUnsavedAlert,
            pendingCallback,
            setPendingCallback
      } = props;
      const [formData, setFormData] = React.useState({});
      const [lookupList, setLookupList] = React.useState({});
      const [showModal, setShowModal] = React.useState(false);
      const [isAiPredictiveOpen, setIsAiPredictiveOpen] = React.useState(true);
      const [aiSuggestions, setAiSuggestions] = React.useState([]);
      const [aiLoading, setAiLoading] = React.useState(false);
      const [aiLoadingStep, setAiLoadingStep] = React.useState(0);
      const [aiError, setAiError] = React.useState('');
      const [selectedSuggestionId, setSelectedSuggestionId] = React.useState(null);
      const [showAiPreviewModal, setShowAiPreviewModal] = React.useState(false);
      const [aiPreviewPayload, setAiPreviewPayload] = React.useState(null);
      const [aiPreviewSuggestion, setAiPreviewSuggestion] = React.useState(null);
      const [aiPreviewSelectedKeys, setAiPreviewSelectedKeys] = React.useState(() => new Set());

      const aiSuggestionsEnabled = props?.profile?.ai_suggestions_enabled ?? false;

      const aiPredictiveCardStyle = {
            padding: "8px",
            borderRadius: "12px",
            border: "2px solid transparent",
            background:
                  "linear-gradient(#fff, #fff) padding-box, linear-gradient(76.49deg, #C6CCFF 0.38%, #F1F3FC 99.62%) border-box",
      };
      const aiPredictiveTitleStyle = {
            color: "#1D2433",
            fontSize: "13px",
            fontWeight: 700,
      };
      const aiPredictiveListStyle = {
            background: "linear-gradient(180deg, #FFE9FF 0%, #FDEFFF 40%, #FDF3FF 100%)",
            padding: "8px",
            maxHeight: "260px",
            overflowY: "auto",
            scrollbarWidth: "thin",
            borderRadius: "8px",
      };
      const aiPredictiveCodeStyle = {
            color: "#1D2433",
            fontSize: "13px",
            fontWeight: 700,
            lineHeight: 1.25,
      };
      const aiPredictiveDescStyle = {
            color: "#4B5563",
            fontSize: "13px",
            lineHeight: 1.35,
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            maxHeight: "2.7em",
      };
      const aiChevronStyle = {
            transform: isAiPredictiveOpen ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.2s ease",
            cursor: "pointer",
      };
      /** Taller than global .sh_basecard (680px) so panels align with left sidebar widgets; tune 220px offset for your header/chrome. */
      const workRestrictionsTallCardStyle = {
            height: "calc(100vh - 220px)",
            minHeight: "820px",
            overflow: "auto",
      };
      const aiLoadingMessages = [
            "Reviewing injury details and clinical findings...",
            "Analyzing pain, range of motion, and functional limits...",
            "Evaluating strength, tolerance, and aggravating activities...",
            "Assessing job demands and work environment...",
            "Determining safe activity and movement restrictions...",
            "Applying evidence-based work limitation guidelines...",
            "Structuring measurable functional restrictions...",
            "Generating work status and restriction timelines...",
            "Finalizing work restriction recommendations..."
      ];
      useEffect(() => {
            fetchLookUp();
            fetchWorkRestrictionData()
      }, [props.isrenderIncident]);
      useEffect(() => {
          props.fetchProgressNotesByScreen()        
      }, [props.selectedSubTab]);

      useEffect(() => {
            if (!props.visit_id || !aiSuggestionsEnabled) return;
            fetchAiSuggestions();
      }, [props.visit_id, aiSuggestionsEnabled]);

      // Refresh work restriction data when refreshEmrTrigger changes (from Start Over)
      useEffect(() => {
            if (props.refreshEmrTrigger !== undefined && props.refreshEmrTrigger > 0) {
                  fetchWorkRestrictionData();
                  setFormData({});
            }
      }, [props.refreshEmrTrigger]);
      useEffect(() => {
            if (!aiLoading) {
                  setAiLoadingStep(0);
                  return;
            }
            const intervalId = setInterval(() => {
                  setAiLoadingStep((prev) => {
                        const next = prev + 1;
                        return next >= aiLoadingMessages.length ? prev : next;
                  });
            }, 2000);
            return () => clearInterval(intervalId);
      }, [aiLoading]);
      const inputField = [
            {
                  type: "Radio",
                  label: "Work Relatedness",
                  placeholder: "",
                  isLabelAppend: true,
                  className: "form-check-input",
                  name: "relatedness",
                  col: 'col-6',
                  optionss: [{
                        label: "Work Related",
                        value: "Work Related"
                  },
                  {
                        label: "First Aid",
                        value: "First Aid"
                  },
                  {
                        label: "Undetermined",
                        value: "Undetermined",
                  },
                  ]
            },
              {
                  type: "Checkbox",
                  label: "Work Status",
                  placeholder: "",
                  isLabelAppend: true,
                  className: "form-check-input",
                  name: "work_status",
                  col: 'col-6',
                  optionss: [{
                        label: "Full duty",
                        value: "Full duty"
                  },
                  {
                        label: "Modified Duty",
                        value: "Modified Duty",
                  },
                    {
                        label: "TTD",
                        value: "TTD",
                  },
                  ]
            },
            {
                  type: "Date",
                  label: "Start Restrictions",
                  placeholder: "Start Restrictions",
                  className: "form-control form-control-solid",
                  name: "restrictions_start_date",
                  col: 'col-6',
            },
            {
                  type: "Date",
                  label: "Stop Restrictions",
                  placeholder: "Stop Restrictions",
                  className: "form-control form-control-solid",
                  name: "restrictions_end_date_or_continued",
                  col: 'col-6',
            },
              {
                  type: "Date",
                  label: "Continue Restrictions",
                  placeholder: "Continue Restrictions",
                  className: "form-control form-control-solid",
                  name: "restrictions_continued_date",
                  col: 'col-6',
            },
             {
                  type: "SelectSearchList",
                  label: "Weight Bearing",
                  placeholder: "",
                  isMulti: true,
                  className: "form-control form-control-solid",
                  name: "weight_bearing",
                  col: 'col-6',
                  options:lookupList?.work_restriction_weight_bearing || []
            },
              {
                  type: "SelectSearchList",
                  label: "Lifting / Carrying",
                  placeholder: "",
                  isMulti: true,
                  className: "form-control form-control-solid",
                  name: "lifting_carrying",
                  col: 'col-6',
                  options:lookupList?.work_restriction_lifting_carrying || []
            },
              {
                  type: "SelectSearchList",
                  label: "Sitting / Standing",
                  placeholder: "",
                  isMulti: true,
                  className: "form-control form-control-solid",
                  name: "sitting_standing",
                  col: 'col-6',
                  options:lookupList?.work_restriction_sitting_standing || []
            },
              {
                  type: "SelectSearchList",
                  label: "Standing Duration",
                  placeholder: "",
                  isMulti: true,
                  className: "form-control form-control-solid",
                  name: "standing_duration",
                  col: 'col-6',
                  options:lookupList?.work_restriction_standing_duration || []
            },
              {
                  type: "SelectSearchList",
                  label: "Walking Distance",
                  placeholder: "",
                  isMulti: true,
                  className: "form-control form-control-solid",
                  name: "walking_distance",
                  col: 'col-6',
                  options:lookupList?.work_restriction_walking_distance || []
            },
              {
                  type: "SelectSearchList",
                  label: "Pushing / Pulling",
                  placeholder: "",
                  isMulti: true,
                  className: "form-control form-control-solid",
                  name: "pushing_pulling",
                  col: 'col-6',
                  options:lookupList?.work_restriction_pushing_pulling || []
            },
              {
                  type: "SelectSearchList",
                  label: "Breaks",
                  placeholder: "",
                  isMulti: true,
                  className: "form-control form-control-solid",
                  name: "work_restriction_breaks",
                  col: 'col-6',
                  options:lookupList?.work_restriction_breaks || []
            },
              {
                  type: "SelectSearchList",
                  label: "Max Shift Length",
                  placeholder: "",
                  // isMulti: true,                                                                                                                                                                                                                                                                                                                               
                  className: "form-control form-control-solid",
                  name: "max_shift_length",
                  col: 'col-6',
                  options:lookupList?.work_restriction_max_shift_length || []
            },
              {
                  type: "SelectSearchList",
                  label: "Equipment Use",
                  placeholder: "",
                  // isMulti: true,
                  className: "form-control form-control-solid",
                  name: "equipment_use",
                  col: 'col-6',
                  options:lookupList?.work_restriction_equipment_use || []
            },
              {
                  type: "SelectSearchList",
                  label: "Overhead Reaching",
                  placeholder: "",
                  // isMulti: true,
                  className: "form-control form-control-solid",
                  name: "overhead_reaching",
                  col: 'col-6',
                  options:lookupList?.work_restriction_overhead_reaching || []
            },
              {
                  type: "SelectSearchList",
                  label: "Repetitive Grasping",
                  placeholder: "",
                  isMulti: true,
                  className: "form-control form-control-solid",
                  name: "repetitive_grasping",
                  col: 'col-6',
                  options:lookupList?.work_restriction_repetitive_grasping || []
            },
              {
                  type: "SelectSearchList",
                  label: "Climbing (stairs / ladders)",
                  placeholder: "",
                  // isMulti: true,
                  className: "form-control form-control-solid",
                  name: "climbing_stairs_ladders",
                  col: 'col-6',
                  options:lookupList?.work_restriction_climbing_stairs_ladders || []
            },
              {
                  type: "SelectSearchList",
                  label: "Squatting / Kneeling",
                  placeholder: "",
                  isMulti: true,
                  className: "form-control form-control-solid",
                  name: "squatting_kneeling",
                  col: 'col-6',
                  options:lookupList?.work_restriction_squatting_kneeling || []
            },
              {
                  type: "SelectSearchList",
                  label: "Bending (back)",
                  placeholder: "",
                  isMulti: true,
                  className: "form-control form-control-solid",
                  name: "work_restriction_bending_back",
                  col: 'col-6',
                  options:lookupList?.work_restriction_bending_back || []
            },  {
                  type: "SelectSearchList",
                  label: "Twisting (spine)",
                  placeholder: "",
                  // isMulti: true,
                  className: "form-control form-control-solid",
                  name: "work_restriction_spine",
                  col: 'col-6',
                  options:lookupList?.work_restriction_spine || []
            },
              {
                  type: "SelectSearchList",
                  label: "DME Use",
                  placeholder: "",
                  isMulti: true,
                  className: "form-control form-control-solid",
                  name: "dme_use",
                  col: 'col-6',
                  options:lookupList?.work_restriction_dme_use || []
            },
              {
                  type: "SelectSearchList",
                  label: "Environmental Exposures",
                  placeholder: "",
                  isMulti: true,
                  className: "form-control form-control-solid",
                  name: "environmental_exposures",
                  col: 'col-6',
                  options:lookupList?.work_restriction_environmental_exposures || []
            },

      ]
        const fetchLookUp=async()=>{
            const lookupKeys=["work_restriction_weight_bearing","work_restriction_lifting_carrying","work_restriction_sitting_standing","work_restriction_standing_duration","work_restriction_walking_distance","work_restriction_pushing_pulling","work_restriction_breaks","work_restriction_max_shift_length","work_restriction_equipment_use","work_restriction_overhead_reaching","work_restriction_repetitive_grasping","work_restriction_climbing_stairs_ladders","work_restriction_squatting_kneeling","work_restriction_bending_back","work_restriction_spine","work_restriction_dme_use","work_restriction_environmental_exposures"]
            try{
               props.Loader(true);
              const results = await Promise.all(
                lookupKeys.map((key) => {
                  // const payload = { key };
                  return IncidentService.getLookUpList(key);
                })
              );
              
              const lookupData = {};
              lookupKeys.forEach((key, index) => {
                lookupData[key] = results[index].map((item) => ({
                  label: item.value,
                  value: item.value
                }));
              });        
              setLookupList({...lookupData})        
      
            }catch(err){
               props.Toast.error("Something went wrong!")
            }finally{
               props.Loader(false);
            }
          }
      const onChangeHandler = (name, value, e,type) => {     
            if (setIsChartingSectionDirty) {
                  setIsChartingSectionDirty(true);
            } 
            if (type === "Checkbox") {
                  let newArray = formData[name]
                        ? formData[name].split(",").filter((item) => item) // convert to array
                        : [];

                  if (e.e.target.checked) {
                        if (!newArray.includes(value)) {
                              newArray.push(value);
                        }
                  } else {
                        newArray = newArray.filter((item) => item !== value);
                  }
                  value = newArray.join(",");
            }
            setFormData((prevState) => ({
                  ...prevState,
                  [name]: value,
            }));
      };
      const fetchWorkRestrictionData=async()=>{
            try {
                  props.Loader(true);
                  const response =await EmrVisitsService.getWorkRestrictionById(props.visit_id)
                  
                  if (response == null) {
                        //     const employerName = this.props.employeeDetails.company.accounts_payable_contact_name
                        //     const employeernumber = this.props.employeeDetails.company.accounts_payable_contact_phone
                        const res = {
                              ...formData,
                              relatedness: "",
                              incident_type: "Injury",
                        }
                        setFormData(res)
                  }else{
                         setFormData(response)
                  }

            } catch (err) {

            } finally {
                  props.Loader(false);
            } 
      }

      const fetchAiSuggestions = async () => {
            if (!props.visit_id || !aiSuggestionsEnabled) return;
            try {
                  setAiLoading(true);
                  setAiError('');
                  const data = await AiDiagnosisService.getSuggestions(props.visit_id, 'work_restrictions');
                  const suggestions = data?.suggestions || [];
                  if (!suggestions.length && props?.visitDetails?.organization_id) {
                        await AiDiagnosisService.generateSuggestionsByVisit(
                              props.visit_id,
                              props.visitDetails.organization_id,
                              props.employeeId || null,
                              'work_restrictions'
                        );
                        const refreshed = await AiDiagnosisService.getSuggestions(props.visit_id, 'work_restrictions');
                        setAiSuggestions(refreshed?.suggestions || []);
                        return;
                  }
                  setAiSuggestions(suggestions);
            } catch (err) {
                  setAiError(err?.message || 'Unable to fetch suggestions');
            } finally {
                  setAiLoading(false);
            }
      }

      const handleAiReload = async (e) => {
            if (e) e.stopPropagation();
            if (!props.visit_id || !props?.visitDetails?.organization_id || !aiSuggestionsEnabled) return;
            try {
                  setAiLoading(true);
                  setAiError('');
                  await AiDiagnosisService.generateSuggestionsByVisit(
                        props.visit_id,
                        props.visitDetails.organization_id,
                        props.employeeId || null,
                        'work_restrictions'
                  );
                  const refreshed = await AiDiagnosisService.getSuggestions(props.visit_id, 'work_restrictions');
                  setAiSuggestions(refreshed?.suggestions || []);
            } catch (err) {
                  setAiError(err?.message || 'Unable to regenerate suggestions');
            } finally {
                  setAiLoading(false);
            }
      }

      const parseSuggestionDescription = (item) => {
            try {
                  if (typeof item?.description === 'string') {
                        const parsed = JSON.parse(item.description);
                        return parsed && typeof parsed === 'object' ? parsed : null;
                  }
            } catch (e) {}
            return null;
      };

      const normalizeAiWorkStatus = (value) => {
            const allowedStatuses = ['Full duty', 'Modified Duty', 'TTD'];
            const rawValues = Array.isArray(value)
                  ? value
                  : String(value || '').split(',');
            const mapped = rawValues
                  .map((entry) => String(entry || '').trim())
                  .filter(Boolean)
                  .map((entry) => {
                        const lowered = entry.toLowerCase();
                        if (lowered === 'light duty' || lowered === 'sedentary only') return 'Modified Duty';
                        if (lowered === 'modified duty') return 'Modified Duty';
                        if (lowered === 'full duty') return 'Full duty';
                        if (lowered === 'ttd') return 'TTD';
                        return '';
                  })
                  .filter(Boolean);
            return Array.from(new Set(mapped.filter((status) => allowedStatuses.includes(status)))).join(',');
      };

      const AI_PREVIEW_WORK_RELATEDNESS_KEYS = new Set([
            'work_relatedness',
            'work_status',
            'start_restrictions',
            'stop_restrictions',
            'continue_restrictions',
      ]);

      const getEmptyWorkRestrictionContent = () => ({
            relatedness: '',
            work_status: '',
            restrictions_start_date: '',
            restrictions_end_date_or_continued: '',
            restrictions_continued_date: '',
            weight_bearing: '',
            lifting_carrying: '',
            sitting_standing: '',
            standing_duration: '',
            walking_distance: '',
            pushing_pulling: '',
            work_restriction_breaks: '',
            max_shift_length: '',
            equipment_use: '',
            overhead_reaching: '',
            repetitive_grasping: '',
            climbing_stairs_ladders: '',
            squatting_kneeling: '',
            work_restriction_bending_back: '',
            work_restriction_spine: '',
            dme_use: '',
            environmental_exposures: '',
            clinical_basis: '',
            restrictions_summary: '',
            duration: '',
            medical_necessity: '',
      });

      const applyAiSuggestionToForm = (item, selectedKeys) => {
            const parsed = parseSuggestionDescription(item);
            if (!parsed) {
                  props.Toast.error('Selected suggestion is not valid.');
                  return null;
            }
            const partial = selectedKeys !== undefined;
            const restrictions = parsed?.restrictions || {};
            const asCsvString = (value) => {
                  if (Array.isArray(value)) return value.filter(Boolean).join(',');
                  if (value === null || value === undefined) return '';
                  if (typeof value === 'object') return '';
                  return String(value);
            };
            let nextFormData = null;
            flushSync(() => {
                  setFormData((prev) => {
                        const applyKey = (key) => {
                              if (!partial) return true;
                              if (AI_PREVIEW_WORK_RELATEDNESS_KEYS.has(key)) return true;
                              return selectedKeys.has(key);
                        };
                        nextFormData = partial
                              ? { ...prev, ...getEmptyWorkRestrictionContent() }
                              : { ...prev };
                        if (applyKey('work_relatedness')) {
                              nextFormData.relatedness = asCsvString(parsed?.work_relatedness);
                        }
                        if (applyKey('work_status')) {
                              nextFormData.work_status = normalizeAiWorkStatus(parsed?.work_status);
                        }
                        if (applyKey('start_restrictions')) {
                              nextFormData.restrictions_start_date = parsed?.start_restrictions;
                        }
                        if (applyKey('stop_restrictions')) {
                              nextFormData.restrictions_end_date_or_continued = parsed?.stop_restrictions;
                        }
                        if (applyKey('continue_restrictions')) {
                              nextFormData.restrictions_continued_date = parsed?.continue_restrictions;
                        }
                        if (applyKey('weight_bearing')) {
                              nextFormData.weight_bearing = asCsvString(restrictions?.weight_bearing);
                        }
                        if (applyKey('lifting_carrying')) {
                              nextFormData.lifting_carrying = asCsvString(restrictions?.lifting_carrying);
                        }
                        if (applyKey('sitting_standing')) {
                              nextFormData.sitting_standing = asCsvString(restrictions?.sitting_standing);
                        }
                        if (applyKey('standing_duration')) {
                              nextFormData.standing_duration = asCsvString(restrictions?.standing_duration);
                        }
                        if (applyKey('walking_distance')) {
                              nextFormData.walking_distance = asCsvString(restrictions?.walking_distance);
                        }
                        if (applyKey('pushing_pulling')) {
                              nextFormData.pushing_pulling = asCsvString(restrictions?.pushing_pulling);
                        }
                        if (applyKey('breaks')) {
                              nextFormData.work_restriction_breaks = asCsvString(restrictions?.breaks);
                        }
                        if (applyKey('max_shift_length')) {
                              nextFormData.max_shift_length = asCsvString(restrictions?.max_shift_length);
                        }
                        if (applyKey('equipment_use')) {
                              nextFormData.equipment_use = asCsvString(restrictions?.equipment_use);
                        }
                        if (applyKey('overhead_reaching')) {
                              nextFormData.overhead_reaching = asCsvString(restrictions?.overhead_reaching);
                        }
                        if (applyKey('repetitive_grasping')) {
                              nextFormData.repetitive_grasping = asCsvString(restrictions?.repetitive_grasping);
                        }
                        if (applyKey('climbing_stairs_ladders')) {
                              nextFormData.climbing_stairs_ladders = asCsvString(restrictions?.climbing_stairs_ladders);
                        }
                        if (applyKey('squatting_kneeling')) {
                              nextFormData.squatting_kneeling = asCsvString(restrictions?.squatting_kneeling);
                        }
                        if (applyKey('bending')) {
                              nextFormData.work_restriction_bending_back = asCsvString(restrictions?.bending);
                        }
                        if (applyKey('twisting')) {
                              nextFormData.work_restriction_spine = asCsvString(restrictions?.twisting);
                        }
                        if (applyKey('dme_use')) {
                              nextFormData.dme_use = asCsvString(restrictions?.dme_use);
                        }
                        if (applyKey('environmental_exposures')) {
                              nextFormData.environmental_exposures = asCsvString(restrictions?.environmental_exposures);
                        }
                        if (!partial) {
                              nextFormData.clinical_basis = asCsvString(parsed?.clinical_basis);
                              nextFormData.restrictions_summary = asCsvString(parsed?.restrictions_summary);
                              nextFormData.duration = asCsvString(parsed?.duration);
                              nextFormData.medical_necessity = asCsvString(parsed?.medical_necessity);
                        }
                        return nextFormData;
                  });
            });
            setSelectedSuggestionId(item?.id || item?.suggestion_id || null);
            if (setIsChartingSectionDirty) setIsChartingSectionDirty(true);
            return nextFormData;
      };

      const applyAiSuggestionAndSaveProgressNote = async (item, selectedKeys) => {
            const mergedFormData = applyAiSuggestionToForm(item, selectedKeys);
            if (!mergedFormData) return false;
            try {
                  props.Loader(true);
                  const toApiMmDdYyyy = (value) => {
                        const raw = String(value || '').trim();
                        if (!raw) return '';
                        // YYYY-MM-DD -> MM-DD-YYYY
                        const ymd = raw.match(/^(\d{4})-(\d{2})-(\d{2})$/);
                        if (ymd) return `${ymd[2]}-${ymd[3]}-${ymd[1]}`;
                        // Already MM-DD-YYYY
                        if (/^\d{2}-\d{2}-\d{4}$/.test(raw)) return raw;
                        const ts = Date.parse(raw);
                        if (Number.isNaN(ts)) return raw;
                        const d = new Date(ts);
                        const mm = String(d.getMonth() + 1).padStart(2, '0');
                        const dd = String(d.getDate()).padStart(2, '0');
                        return `${mm}-${dd}-${d.getFullYear()}`;
                  };
                  const payload = {
                        type: props.VISITCATEGORY === 'Work Comp - New Injury' ? 'incident' : 'no incident',
                        ...mergedFormData,
                        restrictions_start_date: toApiMmDdYyyy(mergedFormData?.restrictions_start_date),
                        restrictions_end_date_or_continued: toApiMmDdYyyy(mergedFormData?.restrictions_end_date_or_continued),
                        restrictions_continued_date: toApiMmDdYyyy(mergedFormData?.restrictions_continued_date),
                  };
                  const res = await EmrVisitsService.SaveWorkRestriction(props.visit_id, payload);
                  if (res?.code === 200) {
                        const suggestionId = item?.id || item?.suggestion_id;
                        const organizationId = props?.visitDetails?.organization_id;
                        if (suggestionId && organizationId && props?.visit_id) {
                              try {
                                    await AiDiagnosisService.acceptSuggestion(suggestionId, organizationId, props.visit_id);
                                    setAiSuggestions((prev) =>
                                          (prev || []).map((s) =>
                                                (s?.id === suggestionId || s?.suggestion_id === suggestionId)
                                                      ? { ...s, is_accepted: true }
                                                      : s
                                          )
                                    );
                              } catch (acceptErr) {
                                    // Do not block form save if accept API fails.
                              }
                        }
                        if (setIsChartingSectionDirty) {
                              setIsChartingSectionDirty(false);
                        }
                        props.fetchProgressNotesByScreen();
                        fetchWorkRestrictionData();
                        if (props.SetFinishedTabs && props.SetFinishedSubTabs && props.selectedTab && props.selectedSubTab) {
                              props.SetFinishedTabs((prev) => (Array.from(new Set([...(prev || []), props.selectedTab]))));
                              props.SetFinishedSubTabs((prev) => (Array.from(new Set([...(prev || []), props.selectedSubTab]))));
                              handleTick(
                                    Array.from(new Set([...(props.finishedTabs || []), props.selectedTab])),
                                    Array.from(new Set([...(props.finishedSubTabs || []), props.selectedSubTab]))
                              );
                        }
                        props.Toast.success('Data saved successfully!');
                        return true;
                  }
                  props.Toast.error('Failed to save AI data to progress note.');
                  return false;
            } catch (err) {
                  props.Toast.error('Failed to save AI data to progress note.');
                  return false;
            } finally {
                  props.Loader(false);
            }
      };

      const buildPreviewFieldRows = (parsed) => {
            if (!parsed) {
                  return { workRelatednessRows: [], workRestrictionRows: [] };
            }
            const restrictions = parsed?.restrictions || {};
            const toDisplay = (v) => {
                  if (Array.isArray(v)) return v.filter(Boolean).join(', ');
                  return v || '';
            };
            const isNonEmpty = (value) => {
                  if (Array.isArray(value)) return value.filter(Boolean).length > 0;
                  return String(value || '').trim() !== '';
            };
            const workRelatednessDefs = [
                  { key: 'work_relatedness', label: 'Work Relatedness', getValue: (p) => p.work_relatedness },
                  { key: 'work_status', label: 'Work Status', getValue: (p) => normalizeAiWorkStatus(p.work_status) },
                  { key: 'start_restrictions', label: 'Start Restrictions', getValue: (p) => p.start_restrictions },
                  { key: 'stop_restrictions', label: 'Stop Restrictions', getValue: (p) => p.stop_restrictions },
                  { key: 'continue_restrictions', label: 'Continue Restrictions', getValue: (p) => p.continue_restrictions },
            ];
            const restrictionDefs = [
                  { key: 'weight_bearing', label: 'Weight Bearing', getValue: () => restrictions.weight_bearing },
                  { key: 'lifting_carrying', label: 'Lifting/Carrying', getValue: () => restrictions.lifting_carrying },
                  { key: 'pushing_pulling', label: 'Pushing/Pulling', getValue: () => restrictions.pushing_pulling },
                  { key: 'standing_duration', label: 'Standing Duration', getValue: () => restrictions.standing_duration },
                  { key: 'walking_distance', label: 'Walking Distance', getValue: () => restrictions.walking_distance },
                  { key: 'sitting_standing', label: 'Sitting/Standing', getValue: () => restrictions.sitting_standing },
                  { key: 'breaks', label: 'Breaks', getValue: () => restrictions.breaks },
                  { key: 'max_shift_length', label: 'Max Shift Length', getValue: () => restrictions.max_shift_length },
                  { key: 'equipment_use', label: 'Equipment Use', getValue: () => restrictions.equipment_use },
                  { key: 'overhead_reaching', label: 'Overhead Reaching', getValue: () => restrictions.overhead_reaching },
                  { key: 'repetitive_grasping', label: 'Repetitive Grasping', getValue: () => restrictions.repetitive_grasping },
                  { key: 'climbing_stairs_ladders', label: 'Climbing Stairs/Ladders', getValue: () => restrictions.climbing_stairs_ladders },
                  { key: 'squatting_kneeling', label: 'Squatting/Kneeling', getValue: () => restrictions.squatting_kneeling },
                  { key: 'bending', label: 'Bending', getValue: () => restrictions.bending },
                  { key: 'twisting', label: 'Twisting', getValue: () => restrictions.twisting },
                  { key: 'dme_use', label: 'DME Use', getValue: () => restrictions.dme_use },
                  { key: 'environmental_exposures', label: 'Environmental Exposures', getValue: () => restrictions.environmental_exposures },
            ];
            const mapDefs = (defs) =>
                  defs
                        .filter((def) => isNonEmpty(def.getValue(parsed)))
                        .map((def) => ({
                              key: def.key,
                              line: `${def.label}: ${toDisplay(def.getValue(parsed))}`,
                        }));
            return {
                  workRelatednessRows: mapDefs(workRelatednessDefs),
                  workRestrictionRows: mapDefs(restrictionDefs),
            };
      };

      const buildOrderedLines = (parsed) => {
            const { workRelatednessRows, workRestrictionRows } = buildPreviewFieldRows(parsed);
            return [...workRelatednessRows, ...workRestrictionRows].map((r) => r.line);
      };

      const buildNarrativeSections = (parsed) => {
            if (!parsed) return [];
            const sections = [
                  { label: 'Clinical basis', value: parsed?.clinical_basis },
                  { label: 'Restrictions', value: parsed?.restrictions_summary },
                  { label: 'Duration', value: parsed?.duration },
                  { label: 'Medical necessity', value: parsed?.medical_necessity },
            ];
            return sections.filter((s) => String(s?.value || '').trim() !== '');
      };

      const openAiPreview = (item) => {
            const parsed = parseSuggestionDescription(item);
            if (!parsed) {
                  props.Toast.error('Selected suggestion is not valid.');
                  return;
            }
            setAiPreviewSuggestion(item);
            setAiPreviewPayload(parsed);
            const { workRestrictionRows } = buildPreviewFieldRows(parsed);
            setAiPreviewSelectedKeys(new Set(workRestrictionRows.map((r) => r.key)));
            setShowAiPreviewModal(true);
      };

      const toggleAiPreviewKey = (key, checked) => {
            setAiPreviewSelectedKeys((prev) => {
                  const next = new Set(prev);
                  if (checked) {
                        next.add(key);
                  } else {
                        next.delete(key);
                  }
                  return next;
            });
      };

      const saveHandler=async()=>{
            try{
                  props.Loader(true);
                  const payload={
                        type:props.VISITCATEGORY==='Work Comp - New Injury' ?'incident':'no incident',
                        ...formData
                  }
                  
                  let res = null
                   res = await EmrVisitsService.SaveWorkRestriction(props.visit_id, payload)
                  
                  if (res.code===200){
                        props.fetchProgressNotesByScreen()
                        setFormData({})
                        fetchWorkRestrictionData()
                        props.SetFinishedTabs((prev) => (Array.from(new Set([...prev, props.selectedTab]))))
                        props.SetFinishedSubTabs((prev) => (Array.from(new Set([...prev, props.selectedSubTab]))))
                        handleTick(Array.from(new Set([...props.finishedTabs, props.selectedTab])),Array.from(new Set([...props.finishedSubTabs,props.selectedSubTab])))
                        props.Toast.success("Data saved successfully!");
                        if (setIsChartingSectionDirty) {
                              setIsChartingSectionDirty(false);
                        }
                        // Open the Work Restrictions Modal after successful save
                        setShowModal(true);
                        return true;
                  }
            }catch(err){
                  props.Toast.error("Something went wrong!")
                  return false;
            }finally{
                   props.Loader(false);
            }
      }
        const handleTick=async(maintabs,subtabs)=>{
          try{
            
            const payload = props.tabData.map((tab) => ({
              ...tab,
              tab_status: maintabs.includes(tab.tab_name) ? "COMPLETED" : "NOT STARTED",
              [tab.tab_name]: tab[tab.tab_name]?.map((subtab) => ({
                ...subtab,
                sub_tab_status: subtabs.includes(subtab.apikey)
                  ? "COMPLETED"
                  : "NOT STARTED",
              })) || [],
            }));
            const response = await EmrConfigService.setTabsListstatus(props.visit_id,payload,props.VISITCATEGORY)
            if(response){
              props.fetchTabsList()
            }
          }catch(err){
      
          }finally{
      
          }
        }
      const handleIncomplete = () => {
            if (setIsChartingSectionDirty) setIsChartingSectionDirty(false);
            props.SetFinishedTabs((prev) => prev.filter(tab => tab !== props.selectedTab))
            props.SetFinishedSubTabs((prev) => prev.filter(subtab => subtab !== props.selectedSubTab))
            handleTick(
              props.finishedTabs.filter(tab => tab !== props.selectedTab), 
              props.finishedSubTabs.filter(subtab => subtab !== props.selectedSubTab)
            )
      }
      const ClearHandler=async()=>{
            const cleardata={
                  ...formData,
                  relatedness: '',
                  work_status: '',
                  restrictions_start_date: '',
                  restrictions_end_date_or_continued: '',
                  restrictions_continued_date: '',
                  weight_bearing: '',
                  lifting_carrying: '',
                  sitting_standing: '',
                  standing_duration: '',
                  walking_distance: '',
                  pushing_pulling: '',
                  work_restriction_breaks: '',
                  max_shift_length: '',
                  equipment_use: '',
                  overhead_reaching: '',
                  repetitive_grasping: '',
                  climbing_stairs_ladders: '',
                  squatting_kneeling: '',
                  work_restriction_bending_back: '',
                  work_restriction_spine: '',
                  dme_use: '',
                  environmental_exposures: ''
            }
            try{
                  props.Loader(true);
                  const  res =  await EmrVisitsService.SaveWorkRestriction(props.visit_id, cleardata)
                  if(res){
                        props.Loader(false);
                        setFormData({})
                        fetchWorkRestrictionData()
                        props.fetchProgressNotesByScreen()
                        
                        // Remove tick from Work Restrictions tab when data is cleared
                        handleIncomplete();
                        
                        props.Toast.success("Data cleared successfully!");
                        if (setIsChartingSectionDirty) {
                              setIsChartingSectionDirty(false);
                        }
                  }
            }catch(err){
                  
            }
            
      
      }
      // Alert handler functions ---
      const handleProceed = () => {
            if(setIsChartingSectionDirty) setIsChartingSectionDirty(false);
            if(setShowUnsavedAlert) setShowUnsavedAlert(false);
            if (pendingCallback) pendingCallback();
            if(setPendingCallback) setPendingCallback(null);
      };
      
      const handleCancel = () => {
            if(setShowUnsavedAlert) setShowUnsavedAlert(false);
            if(setPendingCallback) setPendingCallback(null);
      };
      
  return (
      <>
        <div className="row align-items-stretch">
              {aiSuggestionsEnabled && (
                <div className="col-3 d-flex">
                  <div className="card sh_basecard w-100" style={workRestrictionsTallCardStyle}>
                    <div className="card-body p-2 sh_basecardBody" style={{ overflow: "hidden" }}>
                      <div
                        className="ai-predictive-card d-flex w-100 align-items-center justify-content-between mb-2"
                        style={{ ...aiPredictiveCardStyle, cursor: "pointer" }}
                        role="button"
                        tabIndex={0}
                        onClick={() => setIsAiPredictiveOpen((prev) => !prev)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            setIsAiPredictiveOpen((prev) => !prev);
                          }
                        }}
                      >
                        <div className="d-flex align-items-center gap-2" style={{ minWidth: 0 }}>
                          <span className="ai-predictive-icon d-flex align-items-center justify-content-center">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fillRule="evenodd" clipRule="evenodd" d="M12.0017 16.0019C12.0017 13.7918 13.7933 12.0002 16.0033 12.0002C13.7933 12.0002 12.0017 10.2086 12.0017 7.99854C12.0017 10.2086 10.2101 12.0002 8 12.0002C10.2101 12.0002 12.0017 13.7918 12.0017 16.0019Z" stroke="url(#paint0_linear_ai_wr_card)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M21.0036 12.0001C21.0036 16.9727 16.9725 21.0038 11.9998 21.0038C7.02721 21.0038 2.99609 16.9727 2.99609 12.0001C2.99609 7.02745 7.02721 2.99634 11.9998 2.99634" stroke="url(#paint1_linear_ai_wr_card)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                              <path fillRule="evenodd" clipRule="evenodd" d="M19.0052 7.99835C19.0052 6.34081 20.3489 4.9971 22.0064 4.9971C20.3489 4.9971 19.0052 3.65339 19.0052 1.99585C19.0052 3.65339 17.6615 4.9971 16.0039 4.9971C17.6615 4.9971 19.0052 6.34081 19.0052 7.99835Z" stroke="url(#paint2_linear_ai_wr_card)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                              <defs>
                                <linearGradient id="paint0_linear_ai_wr_card" x1="16.0033" y1="12.0002" x2="8" y2="12.0002" gradientUnits="userSpaceOnUse"><stop offset="0.0625" stopColor="#9AA1FF" /><stop offset="1" stopColor="#4474E6" /></linearGradient>
                                <linearGradient id="paint1_linear_ai_wr_card" x1="21.0036" y1="12.0001" x2="2.99609" y2="12.0001" gradientUnits="userSpaceOnUse"><stop offset="0.0625" stopColor="#9AA1FF" /><stop offset="1" stopColor="#4474E6" /></linearGradient>
                                <linearGradient id="paint2_linear_ai_wr_card" x1="22.0064" y1="4.99709" x2="16.0039" y2="4.99709" gradientUnits="userSpaceOnUse"><stop offset="0.0625" stopColor="#9AA1FF" /><stop offset="1" stopColor="#4474E6" /></linearGradient>
                              </defs>
                            </svg>
                          </span>
                          <p className="mb-0 text-dark font-weight-bold" style={{ ...aiPredictiveTitleStyle, lineHeight: 1.2 }}>
                            AI - Predictive Charting
                          </p>
                        </div>
                        <div className="d-flex align-items-center gap-1">
                          {isAiPredictiveOpen && (
                            <button
                              type="button"
                              className="btn btn-light sh_btnlight d-flex align-items-center justify-content-center"
                              aria-label="Reload suggestions"
                              title="Reload suggestions"
                              onClick={handleAiReload}
                              style={{ width: "34px", height: "34px", padding: 0 }}
                            >
                              <Icons type={"ReloadSuggestions"} size={16} color={"#4B5563"} />
                            </button>
                          )}
                          <span className="ai-secondary-nav-chevron d-flex align-items-center justify-content-center" style={aiChevronStyle}>
                            <svg fill="#000000" width="20" height="20" viewBox="-0.15 -0.225 0.72 0.72">
                              <path d="m0.212 0.085 -0.148 0.148A0.03 0.03 0 0 1 0.021 0.191L0.191 0.021a0.03 0.03 0 0 1 0.042 0l0.17 0.17a0.03 0.03 0 0 1 -0.042 0.042z" />
                            </svg>
                          </span>
                        </div>
                      </div>

                      {isAiPredictiveOpen && (
                        <div className="ai-predictive-card d-flex flex-column" style={aiPredictiveCardStyle}>
                          <div className="ai-predictive-list" style={aiPredictiveListStyle}>
                            {aiLoading && (
                              <div className="d-flex align-items-center justify-content-center py-2 text-center flex-column">
                                <div className="d-flex align-items-center justify-content-center mb-1">
                                  <span
                                    style={{
                                      width: 20,
                                      height: 20,
                                      borderRadius: "50%",
                                      border: "3px solid rgba(126, 224, 255, 0.3)",
                                      borderTopColor: "#7EE0FF",
                                      animation: "aiSpin 0.8s linear infinite",
                                      display: "inline-block",
                                      marginRight: 8,
                                    }}
                                  />
                                  <span style={{ color: "#4B5563", fontSize: "13px", fontWeight: 500, lineHeight: 1.2 }}>
                                    Generating Work <br/> Restrictions...
                                  </span>
                                </div>
                                <div style={{ color: "#6B7280", fontSize: "12px", lineHeight: 1.35 }}>
                                  {aiLoadingMessages[aiLoadingStep]}
                                </div>
                              </div>
                            )}
                            {aiError && (
                              <div style={{ color: "#ff6b6b", fontSize: "13px", fontWeight: "500", padding: "8px", backgroundColor: "rgba(255, 107, 107, 0.1)", borderRadius: "8px" }}>
                                {aiError}
                              </div>
                            )}
                            {!aiLoading && !aiError && aiSuggestions.length === 0 && (
                              <div style={{ color: "#4B5563", fontSize: "13px", textAlign: "center", padding: "8px" }}>
                                No suggestions available.
                              </div>
                            )}
                            {!aiLoading && !aiError && aiSuggestions.map((item, index) => {
                              const isAccepted = (item.id ? selectedSuggestionId === item.id : false) || item.is_accepted || false;
                              const parsedSuggestion = parseSuggestionDescription(item);
                              const orderedLines = buildOrderedLines(parsedSuggestion);
                              const suggestionKey = item.id || item.suggestion_id || `${item.code}-${index}`;
                              let plainDescription = item.description || "";
                              try {
                                if (typeof document !== "undefined") {
                                  const tmp = document.createElement("div");
                                  tmp.innerHTML = plainDescription;
                                  plainDescription = (tmp.textContent || tmp.innerText || "").trim();
                                }
                              } catch (e) {}
                              return (
                                <div
                                  key={`${item.id || item.code}-${index}`}
                                  className={`ai-predictive-item d-flex align-items-start justify-content-between ${index === aiSuggestions.length - 1 ? "mb-0" : "mb-2"}`}
                                  style={{
                                    opacity: isAccepted ? 0.6 : 1,
                                    textDecoration: isAccepted ? "line-through" : "none",
                                    borderBottom: index === aiSuggestions.length - 1 ? "none" : "1px solid #E5E7EB",
                                    paddingBottom: index === aiSuggestions.length - 1 ? 0 : 8,
                                  }}
                                >
                                  <div className="me-3">
                                    <p className="mb-1 font-weight-bold" style={aiPredictiveCodeStyle}>
                                      {item.code || "SHORT VERSION"}
                                    </p>
                                    {parsedSuggestion ? (
                                      <div className="text-muted small">
                                        <div style={{ fontSize: 12, color: "#4B5563", lineHeight: 1.35 }}>
                                          {orderedLines.slice(0, 2).map((line, idx) => (
                                            <div
                                              key={`${suggestionKey}-preview-${idx}`}
                                            >
                                              {line}
                                            </div>
                                          ))}
                                        </div>
                                      </div>
                                    ) : (
                                      <p className="mb-0 text-muted small" style={aiPredictiveDescStyle}>
                                        {plainDescription}
                                      </p>
                                    )}
                                  </div>
                                  <div style={{ paddingTop: "2px" }}>
                                    <input
                                      className=""
                                      type="checkbox"
                                      checked={isAccepted}
                                      onChange={(e) => {
                                        if (e.target.checked) {
                                          openAiPreview(item);
                                        } else {
                                          setSelectedSuggestionId(null);
                                        }
                                      }}
                                    />
                                  </div>
                                </div>
                              );
                            })}
                            <style>{`
                              @keyframes aiSpin {
                                from { transform: rotate(0deg) }
                                to { transform: rotate(360deg) }
                              }
                            `}</style>
                          </div>
                          {!aiLoading && !aiError && aiSuggestions.length > 0 && (
                            <div className="sh_cardFooter border-0 d-flex justify-content-between align-items-center" style={{ zIndex: 2 }}>
                              <small style={{ color: "#4B5563", fontSize: "13px" }}>
                                {`${aiSuggestions.length} suggestions`}
                              </small>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
              <div className={`${aiSuggestionsEnabled ? 'col-9' : 'col-12'} d-flex`}>
                    <div className="card sh_basecard w-100" style={workRestrictionsTallCardStyle}>
                          <div class="card-header p-2 sh_basecardHeader">
                                <div class="d-flex w-100 justify-content-between align-items-center">Work Relatedness
                                      <div class="d-flex">
                                      {formData['work_restriction_id'] && <Buttons
                                                 clickHandler={() => setShowModal(true)}
                                                 className="btn btn-primary sh_btnprimary mr-2"
                                                 acl={PERMISSIONS.WORK_STATUS.EDIT}
                                                 label={"Preview Work Status"} />}
                                            {formData['work_restriction_id'] && <Buttons
                                                  clickHandler={() => ClearHandler()}
                                                  className="btn  sh_btnlight p3-light mr-2"
                                                  acl={'any'}
                                                  isDelete={true}
                                                  label={"Clear All"} />}
                                            <Buttons
                                                  clickHandler={() => saveHandler()}
                                                  className="btn btn-primary sh_btnprimary"
                                                  acl={'any'}
                                                  label={"Accept / Replace"} />
                                      </div>
                                </div>
                          </div>
                          <div class="card-body p-2 sh_basecardBody" >
                                <div className='row'>
                                      {inputField.map((item, index) => {
                                            const value = isSet(formData[item.name], '');
                                            const isWorkRestrictionField = [
                                                  'weight_bearing',
                                                  'lifting_carrying',
                                                  'sitting_standing',
                                                  'standing_duration',
                                                  'walking_distance',
                                                  'pushing_pulling',
                                                  'work_restriction_breaks',
                                                  'max_shift_length',
                                                  'equipment_use',
                                                  'overhead_reaching',
                                                  'repetitive_grasping',
                                                  'climbing_stairs_ladders',
                                                  'squatting_kneeling',
                                                  'work_restriction_bending_back',
                                                  'work_restriction_spine',
                                                  'dme_use',
                                                  'environmental_exposures'
                                            ].includes(item.name);
                                            return (
                                                  <React.Fragment key={`${item.name}-${index}`}>
                                                        {item.name === 'weight_bearing' && (
                                                              <div className="card-header p-2 sh_basecardHeader mb-2" style={{ position: 'static', top: 'auto', zIndex: 'auto', marginTop: '0.75rem' }}>
                                                                    <div className="d-flex w-100 justify-content-between align-items-center">
                                                                          Work Restrictions
                                                                    </div>
                                                              </div>
                                                        )}
                                                  <div className={isWorkRestrictionField ? 'col-sm-6' : 'col-sm-12'}>
                                                        <div className={`form-group row align-items-center ${item.name === 'restrictions_continued_date' ? 'mb-0' : ''}`}>
                                                              <label className={`${isWorkRestrictionField ? 'col-sm-4' : 'col-sm-3'} form-group label mb-0`}>{item.label}</label>
                                                              <div className={isWorkRestrictionField ? 'col-sm-8' : 'col-sm-9'}>
                                                                    {isSet(item.isLabelAppend, false) === true ?
                                                                          <div className='d-flex flex-wrap'>
                                                                                {item?.optionss.map((opt, ind) => {
                                                                                      return (<div className="form-group sh_emrtableformgroup mb-0  col-3  ">
                                                                                            <div className='form-check'>
                                                                                                  <FormInputs {...item} id={`${item.name}-${opt.label}`} value={item.type === 'Checkbox' ? value && value.split(",").includes(opt.value) ? true : false : value === opt.value ? true : false} changeHandler={(val, e) => { onChangeHandler(item.name, opt.value, e, item.type) }} />
                                                                                                                  <label
                                                                                                                        htmlFor={`${item.name}-${opt.label}`}
                                                                                                                        className={'text-nowrap'}
                                                                                                                  >
                                                                                                                        {opt.label}
                                                                                                                  </label>
                                                                                            </div>
                                                                                      </div>)
                                                                                })}
                                                                          </div>
                                                                          :
                                                                          <FormInputs {...item} value={value} changeHandler={(val, e) => { onChangeHandler(item.name, val, e) }} />
                                                                    }
                                                              </div>
                                                        </div>
                                                  </div>
                                                  </React.Fragment>
                                            )
                                      })}
                                </div>
                          </div>
                          </div>
                  </div>
                  
        </div>
<div
  style={{
    display: "flex",
    justifyContent: "flex-end",
    padding: "10px", // optional
  }}
>
  <Buttons
    clickHandler={() => saveHandler()}
    className="btn btn-primary sh_btnprimary"
    acl={'any'}
    label={"Accept / Replace"}
  />
</div>
{showUnsavedAlert && (
          <Alert
            contentTitle="You have unsaved changes. Are you sure you want to navigate away? Changes will be lost."
            content="You have unsaved changes. Are you sure you want to navigate away? Changes will be lost."
            yesButtonName="Discard"
            noButtonName="Cancel"
            type="warning"
            onDelete={handleProceed}   // Discard
            onClose={handleCancel}     // Cancel
            confirmButtonClassName="btn btn-danger"
            cancelButtonClassName="btn btn-secondary"
            saveAndClose={true} 
            onSaveAndClose={async () => { 
              // Call the main save function
              const success = await saveHandler(); // Use this component's save function
              if (success) {
                handleProceed(); // Navigate away if save was successful
              }
            }}
          />
        )}
        {showModal && (
          <WorkRestrictionsModal
          isOpen={showModal}
          onClose={() => setShowModal(false)}
          visit_id={props.visit_id}
          employeeId={props.employeeId}
          employeeDetails={props.employeeDetails}
          fetchEmployeeDetails={props.fetchEmployeeDetails}
          visitDetails={props.visitDetails} 
          />
        )}
        {showAiPreviewModal && (
          <Modal
            show={showAiPreviewModal}
            onHide={() => setShowAiPreviewModal(false)}
            centered
            dialogClassName="work-restrictions-ai-preview-modal"
          >
            <style>{`
              .work-restrictions-ai-preview-modal {
                max-width: 650px;
                width: 100%;
              }
              .work-restrictions-ai-preview-modal .modal-content {
                max-height: 85vh;
                display: flex;
                flex-direction: column;
              }
              .work-restrictions-ai-preview-modal .modal-body {
                padding: 8px 12px;
                overflow: hidden;
                min-height: 0;
              }
              /* Global .sh_basecard uses fixed height + overflow:auto; that nests a second
                 scroller and breaks floated form-check inputs so checkboxes look "stuck". */
              .work-restrictions-ai-preview-modal .card.sh_basecard {
                height: auto !important;
                min-height: 0;
                overflow: visible !important;
              }
              .work-restrictions-ai-preview-modal .ai-preview-scroll {
                max-height: calc(85vh - 170px);
                overflow-y: auto;
                overflow-x: hidden;
                -webkit-overflow-scrolling: touch;
              }
              /* Float-based checkboxes + overflow scroll misalign in WebKit; use flex in this modal only. */
              .work-restrictions-ai-preview-modal .ai-preview-scroll .form-check {
                display: flex;
                align-items: flex-start;
                gap: 0.5rem;
                padding-left: 0;
              }
              .work-restrictions-ai-preview-modal .ai-preview-scroll .form-check .form-check-input {
                float: none !important;
                margin-left: 0 !important;
                margin-top: 0.2em;
                flex-shrink: 0;
                position: relative;
              }
              .work-restrictions-ai-preview-modal .ai-preview-scroll .form-check .form-check-label {
                flex: 1;
                min-width: 0;
              }
            `}</style>
            <Modal.Header closeButton>
              <Modal.Title>
                <h6 className="mb-0">AI Work Restrictions Preview</h6>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="card sh_basecard mb-0">
                <div className="card-body p-2 sh_basecardBody ai-preview-scroll">
                  <p className="mb-2" style={{ fontSize: 13, color: '#4B5563' }}>
                     Select <strong>Work Restrictions</strong>, then click <strong>Apply to Form</strong>. Other fields are read-only for reference.
                  </p>
                  {(() => {
                    const { workRelatednessRows, workRestrictionRows } = buildPreviewFieldRows(aiPreviewPayload);
                    return (
                      <>
                        <p className="mb-1" style={{ fontSize: 13, color: '#000000' }}>
                          <strong>Work Relatedness</strong> 
                        </p>
                        <div className="mb-2 pl-1" style={{ fontSize: 13, color: '#000000' }}>
                          {workRelatednessRows.map((row) => (
                            <div key={row.key} className="mb-1">
                              {row.line}
                            </div>
                          ))}
                        </div>
                        <p className="mb-1 mt-2" style={{ fontSize: 13, color: '#000000' }}>
                          <strong>Work Restrictions</strong>
                        </p>
                        <div className="mb-0">
                          {workRestrictionRows.map((row) => (
                            <div key={row.key} className="form-check mb-1">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id={`ai-preview-rest-${row.key}`}
                                checked={aiPreviewSelectedKeys.has(row.key)}
                                onChange={(e) => toggleAiPreviewKey(row.key, e.target.checked)}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`ai-preview-rest-${row.key}`}
                                style={{ fontSize: 13, color: '#000000' }}
                              >
                                {row.line}
                              </label>
                            </div>
                          ))}
                        </div>
                      </>
                    );
                  })()}
                  {buildNarrativeSections(aiPreviewPayload).length > 0 && (
                    <div className="mt-3 pt-2 border-top" style={{ fontSize: 13, color: '#000000' }}>
                      {buildNarrativeSections(aiPreviewPayload).map((section, idx) => (
                        <p className="mb-1" key={`ai-preview-section-${idx}`}>
                          <strong>{section.label}:</strong> {section.value}
                        </p>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <button
                type="button"
                className="btn sh_btnlight"
                onClick={() => setShowAiPreviewModal(false)}
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary sh_btnprimary"
                onClick={async () => {
                  if (!aiPreviewSuggestion) {
                        setShowAiPreviewModal(false);
                        return;
                  }
                  const ok = await applyAiSuggestionAndSaveProgressNote(aiPreviewSuggestion, aiPreviewSelectedKeys);
                  if (ok) {
                        setShowAiPreviewModal(false);
                  }
                }}
              >
                Apply to Form
              </button>
            </Modal.Footer>
          </Modal>
        )}

                                                  </>
  )
}

export default WithRoutify(WorkRestrictionsTab);